const TermsOfService = () => {
  return (
    <div className="article">
      <div className="card card-style">
        <div className="content">
          <h1>Terms Of Service</h1>
          <br />
          <h2>1. Introduction</h2>
          These Website Standard Terms and Conditions written on this webpage
          shall manage your use of our website, Appollow, accessible at
          appollow.net. By using our Website, you accepted these terms and
          conditions in full. If you disagree with these terms and conditions or
          any part of these terms and conditions, you must not use our Website.
          <br />
          <br />
          <h2>2. Intellectual Property Rights</h2>
          Unless otherwise stated, we or our licensors own the intellectual
          property rights in the website and material on the website. Subject to
          the license below, all these intellectual property rights are
          reserved.
          <br />
          <br />
          <h2>3.License to use website</h2>
          You may view, download for caching purposes only, and print pages from
          the website for your own personal use, subject to the restrictions set
          out below and elsewhere in these terms and conditions. You must not:
          <ol>
            <li>
              republish material from this website (including republication on
              another website);
            </li>

            <li>sell, rent or sub-license material from the website;</li>
            <li>show any material from the website in public;</li>
            <li>
              reproduce, duplicate, copy or otherwise exploit material on our
              website for a commercial purpose;
            </li>
            <li>edit or otherwise modify any material on the website; or</li>
            <li>
              redistribute material from this website except for content
              specifically and expressly made available for redistribution.
              Where content is specifically made available for redistribution,
              it may only be redistributed within your organization.
            </li>
          </ol>
          <br />
          <h2>4. Acceptable use</h2>
          You must not use our website in any way that causes, or may cause,
          damage to the website or impairment of the availability or
          accessibility of the website; or in any way which is unlawful,
          illegal, fraudulent or harmful, or in connection with any unlawful,
          illegal, fraudulent or harmful purpose or activity. You must not use
          our website to copy, store, host, transmit, send, use, publish or
          distribute any material which consists of (or is linked to) any
          spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit
          or other malicious computer software. You must not conduct any
          systematic or automated data collection activities (including without
          limitation scraping, data mining, data extraction and data harvesting)
          on or in relation to our website without our express written consent.
          You must not use our website to transmit or send unsolicited
          commercial communications. You must not use our website for any
          purposes related to marketing without our express written consent.
          <br />
          <br />
          <h2>5. Restricted access</h2>
          We reserve the right to restrict access to areas of our website, or
          indeed our whole website, at our discretion and without notice. If we
          provide you with a user ID and password to enable you to access
          restricted areas of our website or other content or services, you must
          ensure that the user ID and password are kept confidential at all
          times. We reserve the right to disable your user ID and password at
          any time in our sole discretion without notice or explanation.
          <br />
          <br />
          <h2>6. User-generated content</h2>
          You may submit your favorite apps and games on our website for other
          users to discover and view. By submitting content on our website, you
          represent and warrant that you have the right to do so and that the
          content is accurate and not in violation of any intellectual property
          rights or other laws. Appollow reserves the right to remove any
          content that it deems in violation of these terms or otherwise
          inappropriate.
          <br />
          <br />
          <h2>7. App and Game Deals</h2>
          Appollow offers discounts and limited-time free offers on iOS apps and
          games. While we strive to ensure that all information on deals is
          accurate, we do not guarantee the availability or pricing of any apps
          or games. Please contact the app developer or store for the most
          up-to-date information.
          <br />
          <br />
          <h2>8. Disclaimer</h2>
          The website is provided on an &quot;as is&quot; and &quot;as
          available&quot; basis without any representation or endorsement made
        </div>
      </div>
    </div>
  )
}

export default TermsOfService
